// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- using new design system colors */
:root {
    --ds-link-color-outline: var(--ds-color-focus-outline);
    /* LINK STANDARD */
    --ds-link-standard-color: var(--ds-color-grey-20);
    --ds-link-standard-hover-color: var(--ds-color-grey-10);
    --ds-link-standard-active-color: rgb(
        var(--ds-color-grey-20-rgb) / var(--ds-alpha-60)
    );
    /* LINK SUBTLE */
    --ds-link-subtle-color: var(--ds-color-grey-10);
    --ds-link-subtle-hover-color: var(--ds-color-neon-0);
    --ds-link-subtle-active-color: rgb(
        var(--ds-color-neon-0-rgb) / var(--ds-alpha-60)
    );
    /* LINK WRAPPER - used directly in the application */
    --ds-link-wrapper-hover-color: var(--ds-color-grey-indigo-30);
    --ds-link-wrapper-active-color: var(--ds-color-grey-10);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
